<template>
  <transition name="modal">

    <!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">

        <em class="sa-icon sa-info icon-exclamation"></em>
        <h2 class="modal-title ">{{modalTitle}}</h2>
          <p class="modal-paragraph">
            {{questionText}}
            <a target="_blank" v-if="hyperLinkUrl && hyperLinkText" v-bind:href="hyperLinkUrl"> {{hyperLinkText}} </a>
            <span v-if="hyperLinkUrl2 && hyperLinkText2"> and </span>
            <a target="_blank" v-if="hyperLinkUrl2 && hyperLinkText2" v-bind:href="hyperLinkUrl2"> {{hyperLinkText2}} </a>
            {{questionTextAppend}}
          </p>

        <div class="modal-buttons">
            <slot name="body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <button v-if="!hideCancelButton" type="button" @click="hideQuestionModal()" data-dismiss="modal" class="btn btn-info btn-lg btn-cancel">Cancel</button>
                  <button type="button" @click="executeAction()"
                    class="btn btn-info btn-lg btn-accept">{{yesButtonText}}
                  </button>
                </div>
              </div>
            </slot>
          </div>

      </div>
    </div>
  </transition>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex';

  import {
    HIDE_QUESTION_MODAL,
  } from '@/store/mutation-types';

  export default {
    name: 'question',
    computed: {
      ...mapState('question', [
        'modalTitle',
        'questionText',
        'questionTextAppend',
        'hyperLinkUrl',
        'hyperLinkText',
        'hyperLinkUrl2',
        'hyperLinkText2',
        'methodToExecute',
        'yesButtonText',
        'hideCancelButton',
      ]),
    },
    methods: {
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
      }),
      executeAction() {
        this.methodToExecute();
      },
    },
  };
</script>

<style scoped>
  .modal-wrapper p {
    font-size: 16px;
    text-align: center;
  }
  .modal-title {
    color: #127285;
    text-align: center;
  }
  .modal-paragraph {
    margin-bottom: 15px;
  }
  .modal-buttons {
    border-top: 1px solid #e5e5e5;
    position: relative;
    padding: 15px;
    margin-top: 40px;
  }

  .modal-buttons .btn {
    width: 75px;
  }
</style>



// WEBPACK FOOTER //
// Question.vue?8912c596